import React from "react";
import { graphql } from "gatsby";
import { Box, Button, Typography } from "@material-ui/core";
import { formatMultilinesText } from "../../helpers/markdown";
import ChatIcon from "../../components/icons/chat";
import { showIntercom } from "../../services/intercom";
import useAuth from "../../hooks/use-auth";

type Props = Queries.SupportSectionFragmentFragment;

export default function SupportSection({
  title,
  text,
  icon,
  ctaLabel,
  ctaAction
}: Props) {
  let ctaProps = {};
  const { user } = useAuth();
  if (ctaAction === "chat") {
    ctaProps = {
      onClick: () => {
        showIntercom(user);
      }
    };
  } else if (ctaAction === "help_center") {
    ctaProps = {
      href: "http://help.airgraft.com/",
      target: "_blank"
    };
  }

  return (
    <Box
      boxShadow="0px 4px 4px rgba(0, 0, 0, 0.1)"
      paddingX={{ xs: 3, sm: 10 }}
      paddingY={{ xs: 3, sm: 6 }}
      borderRadius="8px"
      bgcolor="grey.100"
    >
      {title && (
        <Box mb={3}>
          <Typography variant="h5">{title}</Typography>
        </Box>
      )}

      {text && (
        <Box mb={3}>
          <Typography
            dangerouslySetInnerHTML={{ __html: formatMultilinesText(text) }}
          />
        </Box>
      )}

      {icon && icon === "chat" && (
        <Box display="flex" justifyContent="center" alignItems="center" mb={3}>
          <ChatIcon color="primary" style={{ fontSize: "5rem" }} />
        </Box>
      )}

      {ctaLabel && ctaAction && (
        <Box mt={3}>
          <Button fullWidth variant="contained" color="primary" {...ctaProps}>
            {ctaLabel}
          </Button>
        </Box>
      )}
    </Box>
  );
}

export const SupportSectionFragment = graphql`
  fragment SupportSectionFragment on DatoCmsCModuleSupportSection {
    title
    text
    icon
    ctaLabel
    ctaAction
    model {
      apiKey
    }
  }
`;
